var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup } from '@easyquery/core';
import { FacetType } from '../types/facet_type';
import { ChartFacet } from '../facets/chart_facet';
import { PivotTableFacet } from '../facets/pivot_table_facet';
import { DataTableFacet } from '../facets/datatable_facet';
var FacetContainer = /** @class */ (function (_super) {
    __extends(FacetContainer, _super);
    function FacetContainer(slot) {
        var _this = _super.call(this, slot) || this;
        _this.facets = [];
        _this.options = {};
        _this.group = WidgetGroup.Result;
        return _this;
    }
    FacetContainer.prototype.destroyCore = function () {
        for (var _i = 0, _a = this.facets; _i < _a.length; _i++) {
            var facet = _a[_i];
            facet.destroy();
        }
        this.clear();
    };
    FacetContainer.prototype.createFacetTab = function (type) {
        var options = this.options[type];
        switch (type) {
            case FacetType.Chart:
                return new ChartFacet(this, options);
            case FacetType.PivotTable:
                return new PivotTableFacet(this, options);
            default:
                return new DataTableFacet(this, options);
        }
    };
    FacetContainer.prototype.getQuery = function () {
        return this.getContext().getQuery();
    };
    return FacetContainer;
}(Widget));
export { FacetContainer };
//# sourceMappingURL=facet_container.js.map